export const sizes = {
  tablet: "834px",
  laptop: "1280px",
  desktop: "1680px",
};
